import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

export default function AdminAds() {
  const [ads, setAds] = useState([]);
  const [f, setF] = useState({ title:'', image_url:'', target_url:'', placement:'home_banner', is_active:1 });
  const [err, setErr] = useState('');

  // ---- Edit state ----
  const [editingAd, setEditingAd] = useState(null);          // the ad object being edited
  const [editForm, setEditForm] = useState({ title:'', image_url:'', target_url:'', placement:'home_banner', is_active:1 });
  const [saving, setSaving] = useState(false);

  const load = async () => { const { data } = await api.get('/admin/ads'); setAds(data.ads||[]); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault(); setErr('');
    try { await api.post('/admin/ads', f); setF({ title:'', image_url:'', target_url:'', placement:'home_banner', is_active:1 }); await load(); }
    catch (e) { setErr(apiError(e)); }
  };
  const toggle = async (a) => { await api.put(`/admin/ads/${a.id}`, { is_active: a.is_active ? 0 : 1 }); await load(); };
  const del = async (a) => { if(window.confirm('Delete ad?')) { await api.delete(`/admin/ads/${a.id}`); await load(); } };

  // ---- Edit handlers ----
  const startEdit = (a) => {
    setErr('');
    setEditingAd(a);
    setEditForm({
      title: a.title || '',
      image_url: a.image_url || '',
      target_url: a.target_url || '',
      placement: a.placement || 'home_banner',
      is_active: a.is_active ? 1 : 0,
    });
  };

  const cancelEdit = () => { setEditingAd(null); };

  const saveEdit = async (e) => {
    e.preventDefault();
    if (!editingAd) return;
    setErr('');
    setSaving(true);
    try {
      await api.put(`/admin/ads/${editingAd.id}`, editForm);
      setEditingAd(null);
      await load();
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-ads">
      <h2 className="mb-3">Advertisements</h2>
      {err && <div className="alert alert-danger">{err}</div>}

      {/* ===== Edit Form (shown when an ad is being edited) ===== */}
      {editingAd && (
        <div className="ap-card mb-3" style={{ border: '2px solid #C7D2FE', background: '#F8FAFF' }} data-testid="edit-ad-form">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">Edit advertisement</h5>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={cancelEdit} disabled={saving} data-testid="edit-cancel-btn">
              Cancel
            </button>
          </div>
          <form onSubmit={saveEdit} className="row g-2">
            <div className="col-md-4">
              <label className="form-label small fw-semibold">Title</label>
              <input
                className="form-control"
                placeholder="Title"
                required
                value={editForm.title}
                onChange={e => setEditForm({ ...editForm, title: e.target.value })}
                data-testid="edit-ad-title"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label small fw-semibold">Image URL</label>
              <input
                className="form-control"
                placeholder="Image URL"
                value={editForm.image_url}
                onChange={e => setEditForm({ ...editForm, image_url: e.target.value })}
                data-testid="edit-ad-image"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label small fw-semibold">Target URL</label>
              <input
                className="form-control"
                placeholder="Target URL"
                value={editForm.target_url}
                onChange={e => setEditForm({ ...editForm, target_url: e.target.value })}
                data-testid="edit-ad-target"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label small fw-semibold">Placement</label>
              <select
                className="form-select"
                value={editForm.placement}
                onChange={e => setEditForm({ ...editForm, placement: e.target.value })}
                data-testid="edit-ad-placement"
              >
                <option value="home_banner">Home banner</option>
                <option value="sidebar">Sidebar</option>
                <option value="listing_top">Listing top</option>
                <option value="category_top">Category top</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label small fw-semibold">Status</label>
              <select
                className="form-select"
                value={editForm.is_active ? 1 : 0}
                onChange={e => setEditForm({ ...editForm, is_active: Number(e.target.value) })}
                data-testid="edit-ad-active"
              >
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>
            <div className="col-md-3 d-flex align-items-end">
              <button className="btn-ap w-100" disabled={saving || !editForm.title.trim()} data-testid="edit-save-btn">
                {saving ? 'Saving…' : 'Save changes'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* ===== Add Form ===== */}
      <div className="ap-card mb-3">
        <form onSubmit={add} className="row g-2" data-testid="add-ad-form">
          <div className="col-md-4"><input className="form-control" placeholder="Title" required value={f.title} onChange={e=>setF({...f,title:e.target.value})} data-testid="ad-title" /></div>
          <div className="col-md-4"><input className="form-control" placeholder="Image URL" value={f.image_url} onChange={e=>setF({...f,image_url:e.target.value})} data-testid="ad-image"/></div>
          <div className="col-md-4"><input className="form-control" placeholder="Target URL" value={f.target_url} onChange={e=>setF({...f,target_url:e.target.value})} data-testid="ad-target"/></div>
          <div className="col-md-3">
            <select className="form-select" value={f.placement} onChange={e=>setF({...f,placement:e.target.value})} data-testid="ad-placement">
              <option value="home_banner">Home banner</option>
              <option value="sidebar">Sidebar</option>
              <option value="listing_top">Listing top</option>
              <option value="category_top">Category top</option>
            </select>
          </div>
          <div className="col-md-3"><button className="btn-ap w-100" data-testid="ad-add-btn">Add advertisement</button></div>
        </form>
      </div>

      {/* ===== Ads Table ===== */}
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Image</th>
              <th>Target</th>
              <th>Placement</th>
              <th>Active</th>
              <th style={{width:260}}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {ads.map(a => (
              <tr key={a.id} data-testid={`ad-row-${a.id}`}>
                <td>{a.title}</td>
                <td>
                  {a.image_url ? (
                    <img
                      src={a.image_url}
                      alt={a.title}
                      style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 6, border: '1px solid #e2e8f0' }}
                      onError={(e) => { e.currentTarget.style.display = 'none'; }}
                    />
                  ) : (
                    <span className="text-muted small">—</span>
                  )}
                </td>
                <td>
                  {a.target_url ? (
                    <a href={a.target_url} target="_blank" rel="noreferrer" className="small text-decoration-none">
                      {a.target_url.length > 30 ? a.target_url.substring(0, 30) + '…' : a.target_url}
                    </a>
                  ) : (
                    <span className="text-muted small">—</span>
                  )}
                </td>
                <td>{a.placement}</td>
                <td>
                  <span
                    className="badge rounded-pill"
                    style={{
                      background: a.is_active ? '#DCFCE7' : '#FEE2E2',
                      color: a.is_active ? '#166534' : '#991B1B',
                      fontWeight: 600,
                      fontSize: '0.72rem',
                      padding: '0.35rem 0.7rem'
                    }}
                  >
                    {a.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>
                  <button
                    className="btn-ap-outline btn-sm me-2"
                    onClick={() => startEdit(a)}
                    data-testid={`ad-edit-${a.id}`}
                  >
                    Edit
                  </button>
                  <button className="btn-ap-outline btn-sm me-2" onClick={()=>toggle(a)} data-testid={`ad-toggle-${a.id}`}>{a.is_active ? 'Disable' : 'Enable'}</button>
                  <button className="btn btn-sm text-danger" onClick={()=>del(a)} data-testid={`ad-del-${a.id}`}>Delete</button>
                </td>
              </tr>
            ))}
            {ads.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center text-muted py-4">
                  No advertisements yet. Add one above.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}